var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c(_vm.tag,{tag:"component",staticClass:"motif:dark",attrs:{"o-base":"flex:h--p:middle-s:middle pad:xEq200 pad:yEq100"}},[_c('p',[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }